import { Box, Image, Text, useDisclosure, useToast } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import ImageFileResizer from 'react-image-file-resizer';
import fileUpload from '../../providers/fileUpload';
import LoadingOverlayText from '../../components/LoadingOverlay/LoadingOverlayText';
import c from '../../constant';

const ImagePicker = ({ initContent = {}, onContentChange, size = 460, label = 'Please choose an Image file' }) => {
	const toast = useToast();
	const { t } = useTranslation();
	const loading = useDisclosure();

	function fileChangedHandler(event) {
		if (event?.target?.files?.length > 0) {
			loading?.onOpen();
			ImageFileResizer.imageFileResizer(
				event.target.files[0],
				size,
				'auto',
				'JPEG',
				90,
				0,
				(mediumUri) => {
					ImageFileResizer.imageFileResizer(
						event.target.files[0],
						90,
						'auto',
						'JPEG',
						90,
						0,
						(iconUri) => {
							let medium = '';
							let icon = '';
							fileUpload(mediumUri)
								.then((result) => {
									medium = result;
									return fileUpload(iconUri);
								})
								.then((result) => {
									loading?.onClose();
									icon = result;
									onContentChange({ medium, icon });
								})
								.catch((error) => {
									loading?.onClose();
									toast({
										title: `Failed to upload images`,
										status: 'error',
										position: 'top-right',
										isClosable: true,
									});
								});
						},
						'file'
					);
				},
				'file'
			);
		}
	}

	return (
		<>
			<Box bg="gray.200" mt={0} mb={4} p={4} borderRadius={c.borderRadius}>
				<Image src={initContent?.medium ? c.baseFilePath + initContent?.medium : ''} w="100%" h="auto" mt="0" />
				<Text fontWeight="bold" mb="2" mt="2">
					{t(label)}
				</Text>
				<input id="file" type="file" accept="image/*" onChange={fileChangedHandler} />
			</Box>
			{loading?.isOpen && <LoadingOverlayText />}
		</>
	);
};

export default ImagePicker;
